/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-explicit-any */

export default (pass: string) => {
  pass = pass.substring(0, 8)

  return pass
}
